module.exports = __webpack_public_path__ + "img/DarkPdf.a3c7fa71.svg";